<!--
  Home（路由 /）

  還原自 index.pretty.js L3160。render function 已轉回 template。

  首頁：主視覺、地址輸入（Google Places 自動完成）、外送／自取二選一，
  以及下方的外送範圍說明地圖（Google My Maps 的 iframe）。

  選外送時會依 Google Directions 的結果計算距離與運費：
    在外送範圍多邊形內  -> 固定 200 元
    在範圍外            -> 每公里 100 元

  主視覺原本是 base64 直接內嵌在 render function 裡（3.6 MB），
  這裡改為一般 import，交給 webpack 產生外部檔案。
-->

<template>
  <div id="wrapper" class="m-all-0 wrapper_flex">
    <div>
      <nav class="min-navbar collapse shadow" :class="{ show: header_show }">
        <div class="nav-container">
          <div class="nav-content d-flex jc-space">
            <p>微微糖・青埔形象店</p>
          </div>
        </div>
      </nav>

      <div class="cover-fill" :style="{ backgroundImage: `url(${heroImage})` }">
        <div class="d-flex jc-space">
          <p class="font-36">微微糖・青埔形象店</p>
        </div>

        <div class="d-flex fd-column-full jc-center">
          <p class="font-48">在微微糖之後</p>
          <p class="font-48"> 我看見妳的微微笑</p>

          <div class="location">
            <div class="mui-textfield" :class="{ is_filled: delivery.location.length > 0 }">
              <GmapAutocomplete
                placeholder=""
                :value="delivery.location"
                @place_changed="set_place"
                @input="get_place"
              />
              <label tabindex="-1">{{ $t('input_location') }}</label>
            </div>

            <div class="location-button d-flex a-center">
              <button
                class="btn"
                :class="apply_enable"
                :disabled="!location_verify"
                @click="set_loaction"
              >
                <p class="t-gray-10 font-18">{{ $t('delivery') }}</p>
              </button>

              <p class="label font-18 t-align-center">or</p>

              <button class="btn btn-primary" @click="set_pickup">
                <p class="t-gray-10 font-18">{{ $t('pick_up') }}</p>
              </button>
            </div>
          </div>

          <div>
            <p
              class="d-inline-block c-pointer td-underline font-18"
              @click="scroll_map"
            >
              {{ $t('learn_more') }}
            </p>
          </div>
        </div>
      </div>

      <div ref="map" class="cover-map">
        <div class="cover-title">
          <p class="title font-24">{{ $t('delivery_description') }}</p>
          <p class="font-16 m-t-12 t-gray-5 font-400">{{ $t('delivery_notes') }}</p>
          <p class="font-16 m-t-8 t-gray-5 font-400">{{ $t('delivery_notes_2') }}</p>
        </div>
        <iframe class="map" :src="map.src" frameborder="0"></iframe>
      </div>

      <!-- 隱藏的 GmapMap：只為了讓 vue2-google-maps 載入 Google Maps SDK，
           set_loaction 需要用到 window.google.maps 的 Geocoder 與 DirectionsService -->
      <div v-show="false">
        <GmapMap
          ref="mapRef"
          class="card-map"
          :center="get_center"
          :zoom="13"
          :options="options"
          map-type-id="roadmap"
        />
      </div>
    </div>

    <v-footer />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import VFooter from '@/components/VFooter.vue'
import * as types from '@/store/mutation-types'
import { isOutsideDeliveryArea, setStorage } from '@/utils'
import heroImage from '@/assets/hero.png'

const STORE_LOCATION = { lat: 25.0142841153413, lng: 121.21120369949432 }

const KEY_ROUTES = '5ew41gf56ew456-routes'
const KEY_ROUTES_RESPONSE = '5ew41gf56ew456-routes-response'
const MONTH = 2592000

export default {
  components: { 'v-footer': VFooter },

  data() {
    const wide = window.innerWidth > 650

    return {
      heroImage,
      header_show: false,
      location_verify: this.getLocation() !== '',
      window_width: window.innerWidth,

      map: {
        src: null,
        ll: wide ? 25.01508233538579 : 25.01808233538579,
        size: wide ? 14 : 13,
        lang: this.getLanguage() === 'tw' ? 'zh-TW' : 'en'
      },

      delivery: {
        location: this.getLocation(),
        start_location: { ...STORE_LOCATION },
        end_location: null,
        center: { ...STORE_LOCATION },
        distance: 0,
        fee: 0,
        time: 0,
        place: null
      },

      options: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        rotateControl: false,
        disableDefaultUi: true,
        clickableIcons: false
      }
    }
  },

  computed: {
    apply_enable() {
      return this.location_verify ? 'btn-primary' : 'btn-grey'
    },

    get_center() {
      return this.delivery.center
    }
  },

  watch: {
    'map.size': {
      deep: true,
      handler() {
        this.bind_map()
      }
    },

    'map.lang': {
      deep: true,
      handler() {
        this.bind_map()
      }
    }
  },

  methods: {
    ...mapActions(['setOrderType', 'setLocation', 'setClientID']),
    ...mapGetters(['getLanguage', 'getLocation']),

    handleScroll() {
      this.header_show = window.scrollY > 10
    },

    onResize() {
      this.window_width = window.innerWidth
      const wide = this.window_width > 650
      this.map.ll = wide ? 25.01508233538579 : 25.01808233538579
      this.map.size = wide ? 14 : 13
    },

    bind_map() {
      this.map.src =
        'https://www.google.com/maps/d/embed?mid=1C6UDshEh2QFc0IqO243citH1sZRfLFin' +
        `&ll=${this.map.ll}%2C121.21524517267949&z=${this.map.size}&hl=${this.map.lang}`
    },

    scroll_map() {
      const top = this.$refs.map.getBoundingClientRect().top
      window.scrollTo({ top: window.scrollY + top - 70, left: 0, behavior: 'smooth' })
    },

    get_place(event) {
      this.delivery.location = event.target.value
      this.location_verify = false
    },

    set_place(place) {
      console.log(place)

      if (place && place.formatted_address) {
        this.delivery.location = place.formatted_address
        this.location_verify = true
      }
    },

    // 原始碼的拼字就是 set_loaction（少了一個 t），保留以免改變對外行為
    set_loaction() {
      if (!this.location_verify) return

      this.setOrderType(types.ORDER_TYPE_DELIVERY)
      this.setLocation(this.delivery.location)

      const geocoder = new window.google.maps.Geocoder()

      geocoder.geocode({ address: this.delivery.location }, (results, status) => {
        if (status !== 'OK') {
          this.delivery.place = null
          this.$emit('event', 'location_update')
          return
        }

        this.delivery.place = results[0]
        this.delivery.end_location = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        }

        this.delivery.center.lat = parseFloat(
          ((this.delivery.start_location.lat + this.delivery.end_location.lat) / 2).toFixed(14)
        )
        this.delivery.center.lng = parseFloat(
          ((this.delivery.start_location.lng + this.delivery.end_location.lng) / 2).toFixed(14)
        )

        const directions = new window.google.maps.DirectionsService()
        const request = {
          origin: this.delivery.start_location,
          destination: this.delivery.end_location,
          travelMode: 'DRIVING'
        }

        directions.route(request, (response, routeStatus) => {
          if (routeStatus !== 'OK') {
            this.$emit('event', 'location_update')
            return
          }

          this.delivery.time = (response.routes[0].legs[0].duration.value / 60) | 0

          if (isOutsideDeliveryArea(this.delivery.end_location)) {
            // 範圍外：每公里 100 元
            /*
             * 不足一公里以一公里計 —— 店家的實際規則。
             * 原本是 Math.round，7.4 公里會算成 700 元，但實際要 800 元。
             * 後端 order_server.js 的 deliveryMinimumSpend 用同一個規則。
             *
             * delivery.distance 是「計費公里數」，同時也是 10 公里上限
             * （MAX_DELIVERY_DISTANCE_KM / MAX_DELIVERY_KM）的比較對象，
             * 所以改成 ceil 之後 10.1~10.9 公里的地址會從「可下單、低消
             * 1000」變成「超出服務範圍」。這與「不足一公里算一公里」
             * 一致 —— 11 公里本來就超過 10 公里上限。
             */
            this.delivery.distance = Math.ceil(response.routes[0].legs[0].distance.value / 1000)
            this.delivery.fee = 100 * this.delivery.distance
          } else {
            // 範圍內：固定 200 元
            this.delivery.distance = 0
            this.delivery.fee = 200
          }

          setStorage(KEY_ROUTES, this.delivery, MONTH)
          setStorage(KEY_ROUTES_RESPONSE, response, MONTH)

          this.next_page()
        })
      })
    },

    set_pickup() {
      this.setOrderType(types.ORDER_TYPE_PICK_UP)
      this.next_page()
    },

    next_page() {
      let path = '/products'
      const drinkId = new URL(location.href).searchParams.get('d')

      if (drinkId !== null) path += `?d=${drinkId}`

      this.$router.push(path)
    }
  },

  created() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.onResize)

    // LINE bot 導進來時會帶 ?q=<LINE user id>
    const clientId = new URL(location.href).searchParams.get('q')
    if (clientId !== null) this.setClientID(clientId)
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.onResize)
  },

  mounted() {
    window.scrollTo(0, 0)
    this.bind_map()
  }
}
</script>
